import { PetStatus } from '../constants/petStatus';

const MEMORIAL_PROFILE_PET_STATUSES = new Set(['memorialized', 'deceased']);

/**
 * True when GET /pets returns a pet in the memorial profile state.
 * Memorial flow uses {@link PetStatus.Memorialized}; legacy responses may still use "deceased".
 */
export function isMemorialProfilePetStatus(petStatus: string | undefined): boolean {
    if (!petStatus) {
        return false;
    }
    return MEMORIAL_PROFILE_PET_STATUSES.has(petStatus.toLowerCase());
}
